// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/TaobaoCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var TaobaoCircleOutlined = function TaobaoCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleOutlinedSvg
  }));
};

TaobaoCircleOutlined.displayName = 'TaobaoCircleOutlined';
export default React.forwardRef(TaobaoCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TaobaoCircleOutlined.js
// module id = 1925
// module chunks = 0